module.exports = __webpack_public_path__ + "static/img/5.48b747c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/5.png
// module id = Wnwm
// module chunks = 0